import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import type { FleetTask, TaskStatus } from '@/types/fleet';

import { fleetKeys } from './fleet-keys';

const TERMINAL_STATUSES: ReadonlySet<TaskStatus> = new Set(['success', 'failure', 'stopped']);

/**
 * Polls a Semaphore task's status (GET /tasks/:task_id) every 2s until it
 * reaches a terminal state. Wired to actions in PR-E #2 — in PR-E #1 the
 * hook exists but nothing produces a task_id yet.
 */
export function useFleetTask(
  taskId: number | undefined,
): UseQueryResult<FleetTask, Error> {
  return useQuery({
    queryKey: fleetKeys.task(taskId ?? -1),
    enabled: Boolean(taskId),
    queryFn: ({ signal }) =>
      apiClient.get<FleetTask>(fleetPath(`/tasks/${taskId}`), signal),
    refetchInterval: (q) => {
      const status = q.state.data?.status;

      return status && TERMINAL_STATUSES.has(status) ? false : 2_000;
    },
  });
}
